var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCardLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank-card-line (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.00618 4H28.0062C28.7426 4 29.3395 4.59696 29.3395 5.33333V26.6667C29.3395 27.4031 28.7426 28 28.0062 28H4.00618C3.26981 28 2.67285 27.4031 2.67285 26.6667V5.33333C2.67285 4.59696 3.26981 4 4.00618 4ZM26.6729 14.6667H5.33952V25.3333H26.6729V14.6667ZM26.6729 12V6.66667H5.33952V12H26.6729ZM18.6729 20H24.0062V22.6667H18.6729V20Z",
    fill: "#0450E1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardLine);
export default __webpack_public_path__ + "static/media/bank-card-line.c7d0426c8cfe1ccc07907cefb3c53476.svg";
export { ForwardRef as ReactComponent };